export const defaultFontFamily = [
  "Direct Sans",
  "Open Sans",
  "Roboto",
  "Helvetica",
  "Arial",
  "sans-serif",
].join(",");
